export { default } from '../(auth)/callback'
